/**
 * Wraps any non-promise value in a promise
 * @param {Object} value
 * @return {Promise}
 * @todo add tests
 */
export function promisify(value) {
  if (value && value.then && typeof value.then === 'function') {
    return value;
  }
  return Promise.resolve(value);
}

/**
 * Get an object literal of the defined query params
 * ie:
 * query = location.search(https://climate.com?clientId=1&field-id=2);
 * queryStringToObject(query) = { clientId: 1, 'field-id': 2 }
 * @param {String} query
 * @return {Object}
 */
export function queryStringToObject(query) {
  if (!query) {
    return {};
  }

  const cleanValues = /^[?#]/.test(query) ? query.slice(1) : query;
  const params = cleanValues.split('&');
  return params.reduce((queryParams, param) => {
    const [key, value] = param.split('=');
    return { ...queryParams, [key]: value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '',};
  }, {});
}
